import axios from 'axios'
import { config } from '../assets/config/config'

const apiUrl = config.api.url

// Helper function to clean chat data before sending to server
const cleanChatData = (chatData) => {
  // Create a copy of the data to avoid modifying the original
  const cleanedData = { ...chatData };
  
  // Remove fields not allowed by the server validation schema
  delete cleanedData.user;
  delete cleanedData.userId;
  delete cleanedData.lastMessage; // Not in schema
  
  // Convert lastUpdated to updatedAt if it exists
  if (cleanedData.lastUpdated) {
    cleanedData.updatedAt = cleanedData.lastUpdated;
    delete cleanedData.lastUpdated;
  }
  
  return cleanedData;
};

// Chat completion - main LLM interaction
const getChatCompletion = (model, messages, stream = false) => {
  return axios.post(`${apiUrl}/v1/chat/completions`, {
    model,
    messages,
    stream
  })
}

// Send message (non-streaming fallback)
const sendMessage = async (messages, model) => {
  try {
    const response = await axios.post(`${apiUrl}/v1/chat/completions`, {
      model,
      messages,
      stream: false
    });
    return response.data;
  } catch (error) {
    console.error('Failed to send message:', error);
    throw error;
  }
};

// Get available models
const getAvailableModels = () => {
  const finalUrl = `${apiUrl}/v1/chat/models`
  return axios.get(finalUrl)
}

// Get usage information
const getUsageInfo = () => {
  return axios.get(`${apiUrl}/v1/chat/usage`)
}

// Get chat history with pagination
const getChatHistory = (params = {}) => {
  return axios.get(`${apiUrl}/v1/chat/history`, { params })
}

// Save or update a full chat
const saveFullChat = (chatData) => {
  const cleanedData = cleanChatData(chatData);
  return axios.post(`${apiUrl}/v1/chat/save`, cleanedData)
}

// Delete a chat
const deleteChat = (chatId) => {
  return axios.delete(`${apiUrl}/v1/chat/${chatId}`)
}

// File management methods
const uploadFile = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  
  return axios.post(`${apiUrl}/v1/chat/files/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

const getUserFiles = () => {
  return axios.get(`${apiUrl}/v1/chat/files`)
}

const deleteFile = (fileId) => {
  return axios.delete(`${apiUrl}/v1/chat/files/${fileId}`)
}

const sendMessageWithFileContext = (messages) => {
  return axios.post(`${apiUrl}/v1/chat/files/ask`, {
    messages
  })
}

export const chatService = {
  getChatCompletion,
  sendMessage,
  getAvailableModels,
  getUsageInfo,
  getChatHistory,
  saveFullChat,
  deleteChat,
  uploadFile,
  getUserFiles,
  deleteFile,
  sendMessageWithFileContext,
} 